import { useAppContext } from "../../hooks/useAppContext";
import Map from "./Map";

interface Props {
  longitude: number;
  latitude: number;
}

const LocationViewer = ({ longitude, latitude }: Props) => {
  const { currentOrganization, organizationConfiguration } = useAppContext();

  const point = {
    type: "point",
    latitude,
    longitude,
  } as __esri.Point;

  return (
    <>
      {organizationConfiguration?.system && (
        <Map
          mapConfig={organizationConfiguration.system.arcGisMap}
          webMapItemId={currentOrganization?.esriConfig?.webMapItemId}
          center={point}
          items={[{ geometry: point }]}
        ></Map>
      )}
    </>
  );
};

export default LocationViewer;
